import { TLoginFormValues } from './LoginForm.types';

export const LOGIN_FORM_DEFAULT_VALUES: TLoginFormValues = {
  email: '',
  password: '',
};
